import { render, staticRenderFns } from "./success.vue?vue&type=template&id=cb60da9e&scoped=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"
import style0 from "./success.vue?vue&type=style&index=0&id=cb60da9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb60da9e",
  null
  
)

export default component.exports